import PropTypes from 'prop-types';

import { useMessages } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import Text from '@zenbusiness/zui/Text';

import { ExtraInfoCardListItem as ListItem } from './ListItem.style';

function SectionListItem({ messageIds, messageValues, ...delegated }) {
  const { title, body } = useMessages(messageIds, messageValues);

  if (!title && !body) {
    return null;
  }

  return (
    <ListItem {...delegated}>
      <Box>
        {title && (
          <Heading gutterBottom={Boolean(body)} size="sm">
            {title}
          </Heading>
        )}
        {body && <Text size="sm">{body}</Text>}
      </Box>
    </ListItem>
  );
}

SectionListItem.propTypes = {
  messageIds: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string
  }),
  messageValues: PropTypes.object
};

export default SectionListItem;
